import Home from './components/HomeContainer';
import './assets/scss/main.css';

export default Home;


// WEBPACK FOOTER //
// ./src/features/Home/index.js